export const environment = {
  production: true,
  baseUrl: 'https://ba01-dev.int.nettask.de:44322'
};
